module.exports = __webpack_public_path__ + "img/1440.93c946e7.jpg";